export const MOVIE_TYPE_LESSON = 1;
export const MOVIE_TYPE_STAFF = 2;

export type MovieTypeProperties =
    | typeof MOVIE_TYPE_LESSON
    | typeof MOVIE_TYPE_STAFF;
